import { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Image, Typography, Row, Col } from 'antd';
import { UserMigrationDetails } from 'all-in-one-shared-api/dist/apis/user/usePatchExistingUser';
import generateKey from 'utils/generateKey';
import { useInterval } from 'hooks/useInterval';
import type { InputRef } from 'antd';
// import mobileIcon from 'assets/images/mobile-icon.svg';
import mobileIcon from 'assets/images/neutral-1.svg';
import emailIcon from 'assets/images/Group 3.svg';
import { RegistrationFlowContext } from 'contexts/registration';
import ProgressSteps from '../components/ProgressSteps';
import styled from 'styled-components';
import {
  Card,
  // Container,
  InvalidTextMsg,
  // OtpInputField,
  ResendCaptchaSection,
  SubTitle,
  // OtpInputContainer,
  // OtpInputWrapper,
  // OtpInput,
  NewInput,
} from './styledComponents';
import { getConfig } from 'configs';
import moment from 'moment';
import { setErrorCodeFun } from '../../../../utils/setErrorCodeFun/setErrorCodeFun';
// import { SessionStorageKey, sessionStorageService } from '../../../../utils/SessionStorageService';
// import { useRegistrationStateQuery } from '../../../../hooks/useRegistrationStateQuery';
import GoogleCaptcha from '../../../../components/googleCaptcha';
// import { getBirthdayString } from 'utils/registration';
// import { useKeycloakReady } from 'hooks';
import {
  // ApiFetcherError,
  useRequestOtp,
  useValidateOtp,
  useEmailOtp,
  useEmailOtpValidate,
  useRegisterEB,
  useLifeUserRegister,
  // useRegister,
  // usePatchExistingUser,
} from 'all-in-one-shared-api';
import './otp.less';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { localStorageService } from 'utils/LocalStorageService';

// import { useKeycloak } from 'all-in-one-react-keycloak';
// import { osName, osVersion } from 'react-device-detect';
const { Title, Text, Link } = Typography;

const RESEND_COUNTDOWN_PERIOD = 60;

const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

interface LocationState extends UserMigrationDetails {
  prevPath?: string;
  saveTodb?: boolean;
  email?: string;
  type?: string;
  selfDefinedLoginId?: string;
  password?: string;
  policyNumber?: string;
  memberType?: string;
  dob?: string;
  pwd?: string;
  birthDate?: string;
  memberId?: string;
  registNum?: boolean;
  areaCode?: string;
}

const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;

  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
export const OtpVerificationPage = (): JSX.Element => {
  const initialValues = useRegistrationStateQuery();
  // console.log('initialValues', initialValues);
  // const [resendCountdown, setResendCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [otpArray, setOtpArray] = useState('');
  const [isAllowEdit, setIsAllowEdit] = useState(false);
  // const { token } = useKeycloakReady();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // const registrationState = useRegistrationStateQuery();
  // const [otpInput, setOtpInput] = useState("");
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [countdown, setCountdown] = useState(RESEND_COUNTDOWN_PERIOD);
  const [requestOtpCount, setRequestOtpCount] = useState(0);
  const [isShowCaptcha, setIsShowCaptcha] = useState(false);
  // const [disabledVerification, setDisabledVerification] = useState(false);
  const { state, selectFlag } = useContext(RegistrationFlowContext);
  const location = useLocation();
  const {
    loginId,
    mobile,
    email,
    countryCode,
    type,
    selfDefinedLoginId,
    password,
    policyNumber,
    memberType,
    birthDate,
    // pwd,
    memberId,
    areaCode,
    // registNum,
  } = (location.state as LocationState) ?? {};
  // console.log(registNum, 'registNum');
  // console.log('location.state', location.state);
  // Note(Anson Kan): assuming `mobile` exists for the current user
  const mobileNumber = (countryCode ?? '') + (areaCode ?? '') + (mobile ?? '');
  const [key, setKey] = useState<string>('');
  const {
    data: lifeRegisterResponse,
    error: lifeRegisterError,
    shouldFetch: shouldLifeRegister,
  } = useLifeUserRegister(
    'life-user—register',
    localStorageService.get('deviceId') ?? '',
    initialValues.identityNo ?? '',
    initialValues.email ?? '',
    initialValues.selfDefinedLoginId ?? '',
    initialValues.confirmPassword ?? '',
    i18n.language,
    initialValues.email ? '' : initialValues.mobile ?? '',
    initialValues.email ? '' : initialValues.countryCode ?? '',
    'WEB',
    initialValues.areaCode ?? '',
    initialValues.dob ? moment(initialValues.dob).format('DD/MM/YYYY') : '',
    selectFlag ?? '',
    initialValues.policyNumber ?? '',
  );
  const {
    data: ebRegisterResponse,
    error: ebRegisterError,
    shouldFetch: shouldEBRegister,
  } = useRegisterEB(
    'eb-user—register',
    localStorageService.get('deviceId') ?? '',
    policyNumber ?? '',
    memberId ?? '',
    // birthDate ? moment(birthDate, 'DD/MM/YYYY').format('DD/MM/YYYY') : '',
    birthDate ? birthDate : '',
    selfDefinedLoginId ?? '',
    password ?? '',
    i18n.language,
    memberType ?? '',
    'WEB',
    countryCode ?? '',
    email ?? '',
    mobile ?? '',
  );
  const { shouldFetch /*, isLoading */ } = useRequestOtp(
    key,
    loginId || initialValues.selfDefinedLoginId || '',
    mobileNumber,
    {
      shouldRetryOnError: false,
      onSuccess: () => {
        shouldFetch(false);
      },
      onError: (error) => {
        if (error) {
          shouldFetch(false);
          // const apiError = error as ApiFetcherError;
          // setErrorMsg(apiError.code ? apiError.code : error.message);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  const { shouldFetch: shouldEmailFetch /*, isLoading */ } = useEmailOtp(
    key,
    loginId || initialValues.selfDefinedLoginId || '',
    email ?? '',
    {
      shouldRetryOnError: false,
      onSuccess: () => {
        shouldEmailFetch(false);
      },
      onError: (error) => {
        if (error) {
          shouldEmailFetch(false);
          // const apiError = error as ApiFetcherError;
          // setErrorMsg(apiError.code ? apiError.code : error.message);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  const [showTips, setShowTips] = useState(false);

  const [validateKey, setValidateKey] = useState<string>('');
  const { shouldFetch: shouldEmailValidate /*, isLoading: isValidating */ } = useEmailOtpValidate(
    validateKey,
    loginId || initialValues.selfDefinedLoginId || '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldEmailValidate(false);
        if (validateResponse) {
          if (validateResponse.success) {
            setErrorMsg(null);
            if (type == 'eb') {
              shouldEBRegister(true);
            } else shouldLifeRegister(true);
          } else {
            setErrorMsg(validateResponse.message);
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            // setErrorMsg(validateResponse.message);
          }
        }
      },
      onError: (error) => {
        if (error) {
          shouldEmailValidate(false);
          const errorMessage = setErrorCodeFun(error.code, i18n.language);
          setErrorMsg(errorMessage ?? error.code ?? error.message);
        }
      },
    },
  );
  const [randoms, setMathRandom] = useState(Math.random());

  const { shouldFetch: shouldValidateOtp } = useValidateOtp(
    'validateOtp' + randoms,
    loginId || initialValues.selfDefinedLoginId || '',
    otpArray,
    {
      shouldRetryOnError: false,
      onSuccess: (validateResponse) => {
        shouldValidateOtp(false);
        if (validateResponse) {
          if (validateResponse.success) {
            if (type == 'eb') {
              shouldEBRegister(true);
            } else shouldLifeRegister(true);
          } else {
            setErrorMsg(validateResponse.message);
            //光標移入第一個輸入框
            if (digit1InputRef.current) {
              digit1InputRef.current.focus();
            } else {
              console.error('digit1InputRef.current is null');
            }
            setOtpArray('');
            // setErrorMsg(validateResponse.message);
          }
        }
      },
      onError: (error) => {
        shouldValidateOtp(false);
        const errorMessage = setErrorCodeFun(error.code, i18n.language);
        setErrorMsg(errorMessage ?? error.code ?? error.message);
      },
    },
  );
  // console.log('state', state);
  useInterval(
    () => {
      setCountdown(countdown - 1);
    },
    countdown >= 0 ? 1000 : null,
  );
  const digit1InputRef = useRef<InputRef>(null);
  // const digit2InputRef = useRef(null);
  // const digit3InputRef = useRef(null);
  // const digit4InputRef = useRef(null);
  // const digit5InputRef = useRef(null);
  // const digit6InputRef = useRef(null);
  // const resendCountdownIntervalID: NodeJS.Timeout | null = null;

  // const startResendCountdown = useCallback(() => {
  //   // 如果计时器已经存在，清除它
  //   if (resendCountdownIntervalID) {
  //     clearInterval(resendCountdownIntervalID);
  //   }
  //   // 设置新的计时器
  //   resendCountdownIntervalID = setInterval(() => {
  //     if (resendCountdown <= 0) {
  //       clearInterval(resendCountdownIntervalID as NodeJS.Timeout); // 强制断言类型为 NodeJS.Timeout
  //     } else {
  //       setResendCountdown(resendCountdown - 1);
  //     }
  //   }, 1000);
  // }, [resendCountdownIntervalID]);
  const handleResendOtp = () => {
    if (!showTips) setShowTips(true);

    if (requestOtpCount < 3) {
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }

    // setOtpInput("");
    setRequestOtpCount(requestOtpCount + 1);
    console.log('onPressResend()->');
    setKey(generateKey());

    setOtpArray('');
    setErrorMsg('life.register.resendOtp');
    if (digit1InputRef.current) {
      digit1InputRef.current.focus();
    }

    // setResendCountdown(RESEND_COUNTDOWN_PERIOD);
    // startResendCountdown();
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  };
  // useEffect(() => {
  //   startResendCountdown();
  //   return () => {
  //     if (resendCountdownIntervalID) {
  //       clearInterval(resendCountdownIntervalID);
  //     }
  //   };
  // }, [startResendCountdown, resendCountdownIntervalID]);
  useEffect(() => {
    if (requestOtpCount >= 3) {
      setIsShowCaptcha(true);
    }
  }, [requestOtpCount]);
  useEffect(() => {
    setKey(generateKey());
    // console.log('============================', location.state);
    // 如果email存在，那麼shouldEmailFetch(true),否則shouldFetch(true)
    if (email) {
      shouldEmailFetch(true);
    } else if (mobile) {
      shouldFetch(true);
    }
  }, [email, mobile, shouldEmailFetch, shouldFetch]);
  const handleVerifyOtp = useCallback(() => {
    if (!/\d{6}/.test(otpArray)) {
      setErrorMsg(t('smsOtpVerification.code-not-found'));
      return;
    }

    setValidateKey(generateKey());
    if (email) {
      shouldEmailValidate(true);
    } else if (mobile) {
      shouldValidateOtp(true);
    }

    // mutateVerifyOtp();
  }, [otpArray, email, mobile, setErrorMsg, setValidateKey, shouldEmailValidate, shouldValidateOtp, t]);
  useEffect(() => {
    if (otpArray.length === 6) {
      setMathRandom(Math.random());
      handleVerifyOtp();
    }
  }, [otpArray, handleVerifyOtp]);
  useEffect(() => {
    if (errorMsg && errorMsg == 'smsOtpVerification.retry-limit-exceeded') {
      setIsAllowEdit(true);
      setOtpArray('');
      // setCountdown(30);
      setCountdown(RESEND_COUNTDOWN_PERIOD);
    }
  }, [errorMsg]);
  useEffect(() => {
    if (countdown === 0) {
      setIsAllowEdit(false);
    }
  }, [countdown]);
  // const { keycloak } = useKeycloak();
  // const startUsing = async () => {
  //   await loginWithRetry(state.selfDefinedLoginId || '', state.confirmPassword || '', 0);
  //   // 使用 replace 代替 reset，来模拟重置历史记
  //   console.log(
  //     type === 'eb' ? [ebRegisterResponse] : lifeRegisterResponse?.lifeInsuranceList,
  //     'confirmdata----------',
  //   );
  //   navigate(type === 'eb' ? '/addConfirmEb' : '/addConfirm', {
  //     replace: true,
  //     state: {
  //       lifeCardData: type === 'eb' ? [ebRegisterResponse] : lifeRegisterResponse?.lifeInsuranceList,
  //       life: type === 'eb' ? false : true,
  //     },
  //   });
  // };
  // const loginWithRetry = useCallback(
  //   (username: string, password: string, maxAttempts: number) => {
  //     return new Promise<void>((resolve, reject) => {
  //       const keycloakLogin = async (attempt = 1) => {
  //         try {
  //           await keycloak.login({
  //             username,
  //             password,
  //             device: osName,
  //             deviceVersion: osVersion,
  //           });
  //           resolve();
  //         } catch (error: unknown) {
  //           const errorMessage = error instanceof Error ? error.message : undefined;
  //           // console.log('loginWithRetry()->error from keycloak.login():', errorMessage);
  //           if ((errorMessage && !errorMessage.includes('auth error')) || attempt > maxAttempts) {
  //             reject(error);
  //           } else {
  //             setTimeout(() => keycloakLogin(attempt + 1), 500);
  //           }
  //         }
  //       };

  //       keycloakLogin();
  //     });
  //   },
  //   [keycloak],
  // );
  /* eslint-disable */
  // useEffect(() => {
  //   console.log(registNum, 'location.state.registNum');
  // }, [location]);
  useEffect(() => {
    if (lifeRegisterResponse && !lifeRegisterError) {
      // console.log('lifeRegisterResponse ------------------------', lifeRegisterResponse);
      shouldLifeRegister(false);
      // if (registNum) {
      //   startUsing();
      // } else {
      navigate('/register/RegistrationConfirm', {
        replace: true,
        state: {
          lifeCardData: lifeRegisterResponse.lifeInsuranceList,
          life: true,
          username: initialValues.selfDefinedLoginId || selfDefinedLoginId,
          password: initialValues.confirmPassword || password,
        },
      });
      // }
    } else if (lifeRegisterError?.code) {
      shouldLifeRegister(false);
      const errorMessage = setErrorCodeFun(lifeRegisterError.code, i18n.language);
      // if (!lifeRegisterError.message) {
      //   return setErrorMessage('common.error.generic');
      // }
      // if (lifeRegisterError.code === 'auth.register.unreg.dob') {
      //   return setErrorMessage('registration.error.invalidDob');
      // } else if (lifeRegisterError.code === 'auth.register.unreg.user') {
      //   return setErrorMessage('registration.error.userNotFound');
      // } else if (lifeRegisterError.code === 'dapi.user.account.exists') {
      //   return setErrorMessage('registration.error.existingUser');
      // }

      setErrorMsg(errorMessage);
    }
  }, [lifeRegisterResponse, lifeRegisterError, i18n.language, navigate, shouldLifeRegister, state]);
  useEffect(() => {
    if (ebRegisterResponse && !ebRegisterError) {
      // console.log('ebRegisterResponse ------------------------', ebRegisterResponse);
      shouldEBRegister(false);
      // if (registNum) {
      //   startUsing();
      // } else {
      navigate('/register/RegistrationConfirm', {
        state: {
          lifeCardData: [ebRegisterResponse],
          // life: true,
          username: initialValues.selfDefinedLoginId || selfDefinedLoginId,
          password: initialValues.confirmPassword || password,
        },
      });
      // }
    } else if (ebRegisterError?.code) {
      shouldEBRegister(false);
      const errorMessage = setErrorCodeFun(ebRegisterError.code, i18n.language);

      setErrorMsg(errorMessage);
    }
  }, [ebRegisterResponse, ebRegisterError, i18n.language, navigate, shouldEBRegister, state]);

  const onCaptchaSuccess = () => {
    setIsShowCaptcha(false);
  };

  const onCaptchaError = () => {
    setErrorMsg(t('login.error.captchaDigitError'));
  };
  // const onOtpKeyPress = (index: number) => {
  //   return (event: React.KeyboardEvent) => {
  //     const value = event.key;

  //     if (value === 'Backspace' && otpArray[index] === '') {
  //       // 清除前一个输入框的值
  //       if (index > 0) {
  //         const otpArrayCopy = [...otpArray];
  //         otpArrayCopy[index - 1] = '';
  //         setOtpArray(otpArrayCopy);
  //       }

  //       // 自动聚焦到前一个输入框
  //       const prevInputIndex = index - 1;
  //       if (prevInputIndex >= 0) {
  //         (document.querySelectorAll('.single-digit-input')[prevInputIndex] as HTMLInputElement)?.focus();
  //       }

  //       setErrorMsg(null);
  //     }
  //   };
  // };
  const onOtpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) {
      return;
    }
    setOtpArray(e.target.value);
    setErrorMsg(null);
    // 确保输入的是数字

    // return (event: React.ChangeEvent<HTMLInputElement>) => {
    //   const value = event.target.value;

    //   // 确保输入的是数字
    //   if (isNaN(Number(value))) {
    //     return;
    //   }

    //   const otpArrayCopy = [...otpArray]; // 创建otpArray的副本
    //   otpArrayCopy[index] = value;
    //   setOtpArray(otpArrayCopy);

    //   // 如果输入不为空，自动聚焦到下一个输入框
    //   if (value !== '') {
    //     const nextInputIndex = index + 1;
    //     if (nextInputIndex < otpArray.length) {
    //       (document.querySelectorAll('.single-digit-input')[nextInputIndex] as HTMLInputElement)?.focus();
    //     }
    //   }

    //   setErrorMsg(null);
    // };
  };
  function maskEmail(email: string) {
    if (!email) return '';
    // ???????????????
    const [username, domain] = email.split('@');
    // const [domains, coms,countrys] = domain.split('.');
    const domainList = domain.split('.');

    // ???????,???1???1?,???*??
    const maskedUsername = username.charAt(0) + '*'.repeat(username.length - 2) + username.slice(-1);
    const maskedDomain = domainList[0].charAt(0) + '*'.repeat(domainList[0].length - 2) + domainList[0].slice(-1);
    if (domainList.length > 2) {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1] + '.' + domainList[2];
    } else {
      return maskedUsername + '@' + maskedDomain + '.' + domainList[1];
    }
    // ??????????
  }
  function maskPhoneNumber(phoneNumber: string) {
    if (!phoneNumber) return '';
    // ???3???4?,???*??
    const visibleDigits = 2; // ????,??????????
    const startDigits = phoneNumber.substring(0, visibleDigits);
    const endDigits = phoneNumber.substring(phoneNumber.length - 2);

    // ?????*?????
    const maskedPart = '*'.repeat(phoneNumber.length - visibleDigits - 2);

    // ??????????
    return startDigits + maskedPart + endDigits;
  }
  return (
    <ResponsiveContainer>
      <div
        className="register_otp_wrapper"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          padding: '20px',
        }}
      >
        <Card style={{ border: 0, width: '100%', maxWidth: '400px' }}>
          <ProgressSteps activeStepIndex={1} />
          <Row justify="center" gutter={[16, { xs: 8, sm: 16, md: 24 }]}>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <Space align="center" direction="vertical"> */}
              <Title level={3} style={{ marginTop: '30px', fontSize: '26px', color: '#20252B' }}>
                {t('smsOtpVerification.screenTitle')}
              </Title>
            </Col>
            {!email && showTips && (
              <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
                <Title level={3} style={{ fontSize: '20px', color: 'red' }}>
                  {type == 'eb' ? t('sms.othersOtpEb') : t('sms.othersOtpLife')}
                </Title>
              </Col>
            )}
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <Image height="176px" className="img_container" src={email ? emailIcon : mobileIcon} preview={false} />
              {/* </Space> */}
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <SubTitle
                style={{ display: 'inline-block', textAlign: 'center', fontSize: '20px', fontFamily: 'Roboto400' }}
              >
                {email ? t('smsOtpVerification.emailScreenSubtitle') : t('smsOtpVerification.mobileScreenSubtitle')}
                <br />
                {email
                  ? maskEmail(email)
                  : mobile
                  ? countryCode + '  ' + (areaCode ? `${areaCode} ` : '') + maskPhoneNumber(mobile)
                  : null}
              </SubTitle>
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              {/* <OtpInputContainer className="otp_input_container">
                {[digit1InputRef, digit2InputRef, digit3InputRef, digit4InputRef, digit5InputRef, digit6InputRef].map(
                  (textInputRef, index) => (
                    <OtpInputWrapper key={index}>
                      <input
                        style={{
                          width: '40px',
                          height: '40px',
                          textAlign: 'center',
                          fontSize: '20px',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                        }}
                        type="text"
                        maxLength={1}
                        value={otpArray[index]}
                        onKeyPress={onOtpKeyPress(index)}
                        onChange={onOtpChange(index)}
                        className="single-digit-input"
                        autoFocus={index === 0}
                        ref={textInputRef}
                        disabled={isAllowEdit}
                      />
                    </OtpInputWrapper>
                  ),
                )}
              </OtpInputContainer> */}
              <NewInput
                maxLength={6}
                value={otpArray}
                onChange={onOtpChange}
                className="single-digit-input"
                autoFocus
                ref={digit1InputRef}
                disabled={isAllowEdit}
              />
            </Col>
            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {errorMsg && <InvalidTextMsg type="danger">{t(errorMsg)}</InvalidTextMsg>}
            </Col>

            <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <ResendCaptchaSection>
                {isShowCaptcha ? (
                  <GoogleCaptcha
                    hl={i18n.language}
                    sitekey={config.captchaSiteKey}
                    onChange={onCaptchaSuccess}
                    onError={onCaptchaError}
                    onExpired={onCaptchaError}
                  />
                ) : (
                  <>
                    <Link
                      onClick={countdown > 0 ? (e) => e.preventDefault() : handleResendOtp}
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        pointerEvents: countdown > 0 ? 'none' : 'auto',
                        color: countdown > 0 ? 'gray' : '#752127', // 设置禁用时颜色为灰色
                      }}
                    >
                      {t('smsOtpVerification.resend')}
                    </Link>
                    {countdown >= 0 && (
                      <Text type="secondary" style={{ color: '#20252B', fontSize: '17px', marginTop: 20 }}>
                        {t('smsOtpVerification.resendCountdownText', {
                          second: countdown,
                        })}
                      </Text>
                    )}
                  </>
                )}
              </ResendCaptchaSection>
            </Col>

            {/* <Col xs={24} md={24} style={{ display: 'flex', justifyContent: 'center' }}>
              <div className="form_btn" style={{ width: '100%' }}>
                <Button
                  block
                  type="primary"
                  className="btn"
                  disabled={disabledVerification}
                  size="large"
                  onClick={handleVerifyOtp}
                >
                  {t('common.submit')}
                </Button>
              </div>
            </Col> */}
            <Link
              onClick={() => {
                navigate('/login');
              }}
              style={{
                fontSize: '17px',
                fontFamily: 'Roboto400',
                marginLeft: 4,
                marginRight: 4,
                color: '#C21B17',
                textDecoration: 'underline',
              }}
            >
              {t('common.cancel')}
            </Link>
          </Row>
        </Card>
      </div>
    </ResponsiveContainer>
  );
};
